import React, { Component } from "react";
import {
  message,
  Spin,
  Row,
  Col,
  Divider,
  Select,
  Input,
  Tabs,
  Modal,
} from "antd";
import {
  MensajeError,
    dineroDisabledMask,
    Form,
    FormItem,
    SelectItem,
    DatePickerItem,
    InputItem,
    ButtonItem,
    SwitchItem,
    ErrorItem,
    HeaderItem,
    BoxItem,
} from "../../../Components/Items";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import { PlusOutlined } from "@ant-design/icons";
import ElegirTipoDeCliente from "../../Panel/Clientes/ElegirTipoDeCliente/ElegirTipoDeCliente";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import MandarCorreo from "../../Panel/Ventas/MandarCorreo/MandarCorreo";
import qz from 'qz-tray';
import ticketPdf from "../../../Pdf/ticketPdf";
import printJS from "print-js";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

moment.locale("es");

const { Option } = Select;
const { TabPane } = Tabs;

class ModalGenerarFactura extends Component {
    formRef = React.createRef();

    state = {
        loading: false,
        datosVenta: undefined,
        todasClientes: null,
        objetoClientes: null,
        objetoUsosDeCFDI: null,
        todasUsosDeCFDI: null,
        modalElegirTipoDeCliente: false,
        modalElegirTipoDeClienteId: null,
        modalElegirTipoDeClienteNombre: null,
        modalCorreo: false,
        modalCorreoId: null,
        complementoDetallista: false,
        detallista: null,
        todasRegimenFiscal: null,
        objetoRegimenFiscal: null,
        activarRegimenes: false,
        todasRegimenFiscalCliente: [],
        objetoRegimenFiscalCliente: [],
        todasFormasDePago: [],
        objetoFormasDePago: [],
        contado: 1
    };

    componentDidUpdate(prevProps) {
        const becameVisible = !prevProps.visible && this.props.visible;
        const ventaCambio = prevProps.ventaId !== this.props.ventaId;
        if ((becameVisible || ventaCambio) && this.props.visible && this.props.ventaId) {
            // reset form si cambia la venta
            this.formRef.current?.resetFields();
            this.setState(
                {
                    datosVenta: undefined,
                    todasClientes: null,
                    objetoClientes: null,
                    objetoUsosDeCFDI: null,
                    todasUsosDeCFDI: null,
                    complementoDetallista: false,
                    detallista: null,
                    modalElegirTipoDeCliente: false,
                    modalElegirTipoDeClienteId: null,
                    modalElegirTipoDeClienteNombre: null,
                    modalCorreo: false,
                    modalCorreoId: null,
                    todasRegimenFiscal: null,
                    objetoRegimenFiscal: null,
                    activarRegimenes: false,
                },
                () => this.consultarTodo()
            );
        }
    }

    async consultarTodo() {
        this.setState({ loading: true });
        try {
            // Usos de CFDI
            const usosReq = axios.post(
                "usodecfdi/selectUsosDeCFDI",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            );

            // Clientes (sugeridos/iguales a la venta)
            const clientesReq = axios.post(
                "clientes/selectClientesIguales",
                { empresaId: this.props.empresaId, ventaId: this.props.ventaId },
                { headers: this.props.headersToken }
            );

            // Datos de la venta
            const ventaReq = axios.post(
                "ventas/datosVentaPRecibirP",
                { empresaId: this.props.empresaId, ventaId: this.props.ventaId },
                { headers: this.props.headersToken }
            );

            // Regímenes
            const regimenReq = axios.post(
                "ventas/selectDatosParaRegimen",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            );

            const [usosRes, clientesRes, ventaRes, regimenRes] = await Promise.all([
                usosReq,
                clientesReq,
                ventaReq,
                regimenReq,
            ]);

            // Usos de CFDI
            if (usosRes?.data && usosRes.data.status !== 404) {
                const lista = usosRes.data;
                this.setState({
                    todasUsosDeCFDI: lista,
                    objetoUsosDeCFDI: lista.map((value) => (
                        <Option value={value._id} key={value._id}>
                            {value?.c_UsoCFDI + ' - ' + value.descripcion}
                        </Option>
                    )),
                });
            }

            // Clientes
            if (clientesRes?.data && clientesRes.data.status !== 404) {
                const lista = clientesRes.data;
                this.setState({
                    todasClientes: lista,
                    objetoClientes: lista.map((value) => (
                        <Option value={value._id} key={value._id}>
                            {value.stringBuscar}
                        </Option>
                    )),
                });
            }

            // Venta
            if (!ventaRes?.data || ventaRes.data.status === 404) {
                message.error("Error: no se encontró información de la venta");
            } else {
                const v = ventaRes.data.venta;
                this.setState({
                    objetoRegimenFiscalCliente: ventaRes.data.regimenesFiscales?.map((value) => {
                        return (
                            <Option value={value._id} key={value._id}>
                                {value.c_RegimenFiscal + " - " + value.descripcion}
                            </Option>
                        );
                    }),
                    todasRegimenFiscalCliente: ventaRes.data.regimenesFiscales,
                    objetoFormasDePago: ventaRes.data.formasDePago.map((value) => {
                        return (
                            <Option value={value._id} key={value._id}>
                                {value.c_FormaPago + " - " + value.descripcion}
                            </Option>
                        );
                    }),
                    todasFormasDePago: ventaRes.data.formasDePago,
                    datosVenta: v,
                    contado: v.contado,
                    complementoDetallista: v.cliente.complementoDetallista,
                    detallista: {
                        orderIdentification: v.cliente.orderIdentification,
                        referenceDateOrderIdentification: v.cliente.referenceDateOrderIdentification,
                        additionalInformation: v.cliente.additionalInformation,
                        deliveryNote: v.cliente.deliveryNote,
                        referenceDateDeliveryNote: v.cliente.referenceDateDeliveryNote,
                    },
                });
                this.formRef.current?.setFieldsValue({
                    usoDeCfdiId: v.cliente.usoDeCFDIID,
                    regimenClienteFiscalId: v.cliente?.regimenFiscalId,
                    formaDePagoId: v.formaDePagoId,
                    ordenDeCompra: v.ordenDeCompra
                });
            }

            // Regímenes
            if (regimenRes?.data?.success === 2) {
                const { regimenesFiscales, activarRegimenes, regimenDefaultId } = regimenRes.data;
                this.setState({
                    objetoRegimenFiscal: regimenesFiscales.map((value) => (
                        <Option value={value._id} key={value._id}>
                            {value.c_RegimenFiscal + " - " + value.descripcion}
                        </Option>
                    )),
                    activarRegimenes,
                    todasRegimenFiscal: regimenesFiscales,
                });
                if (activarRegimenes) {
                    this.formRef.current?.setFieldsValue({ regimenFiscalId: regimenDefaultId });
                }
            } else {
                message.warning("No se encontraron datos de regímenes fiscales");
            }
        } catch (e) {
            message.error("Ocurrió un error al consultar datos");
        } finally {
            this.setState({ loading: false });
        }
    }

    onFinishFailed = (e) => {
        ErrorItem(e);
    };

    onFinish = (values) => {
        this.setState({ loading: true });
        axios
            .post(
                "ventas/generarFactura",
                {
                    ...values,
                    empresaId: this.props.empresaId,
                    ventaId: this.props.ventaId,
                    sesionId: this.props.sesionId,
                },
                { headers: this.props.headersToken }
            )
            .then(async (res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se ha generado una factura de la venta");
                    if (res.data.avisoPolizas) message.warning(res.data.avisoPolizas, 8);
                    this.setState({ modalCorreo: true, modalCorreoId: res.data.ventaId });

                    // Imprimir ticket si se requiere
                    if (res.data.imprimirTicket) {
                        this.printTicket(res.data)
                    }


                    this.props.onConfirm()

                    // Notificar al padre si lo requiere (para refrescar grids, etc.)
                    this.props.onFacturada?.(res.data);
                } else if (res.data.success === 1) {
                    MensajeError({
                      message: res.data.errorTimbrado?.titulo || res.data.message || "No se puede generar la factura",
                      description: res.data.errorTimbrado?.mensaje || res.data.description,
                      detalleTecnico: res.data.errorTimbrado?.detalleTecnico,
                    });
                } else {
                    message.error("Hubo un error y no se generó la factura");
                }
            })
            .catch(() => {
                this.setState({ loading: false });
                message.error("Error al generar la factura");
            });
    };

    printTicket = async (dataTicket) => {
        try {

            if (!this.props.impresoraSeleccionada) {
                throw new Error("No hay impresora seleccionada");
            }

            if (!qz.websocket.isActive()) {
                await qz.websocket.connect();
            }

            const config = await qz.configs.create(this.props.impresoraSeleccionada ? this.props.impresoraSeleccionada : "",
                {
                    encoding: 'Cp1252',
                    scaleContent: false,     // No escalar el contenido del PDF
                    rasterize: true,        // Evita convertir a imagen si no quieres que reduzca resolución
                    density: 300             // Ajusta según tu impresora (203 o 300 dpi típico)
                }
            );


            // const data = ticketEscPos(dataTicket);
            const pdf2 = ticketPdf({ ...dataTicket, factura: true });
            const base64_1 = await new Promise((resolve) => {
                pdfMake.createPdf(pdf2).getBase64((base64) => resolve(base64));
            });

            await qz.print(config, [
                {
                    type: 'pixel',
                    format: 'pdf',
                    flavor: 'base64',
                    data: base64_1
                },
            ]);

            await qz.websocket.disconnect();
            // await qz.print(config, data);

        } catch (err) {
            console.error('Error imprimiendo ticket:', err);
            const pdf2 = ticketPdf({ ...dataTicket, factura: true });
            pdfMake.createPdf(pdf2).getBlob((blob) => {
                const pdfURL = URL.createObjectURL(blob);

                const ua = navigator.userAgent || "";
                const isAndroid = /Android/i.test(ua);

                // Chrome en iOS aparece como "CriOS"
                const isChromeiOS = /CriOS/i.test(ua);

                // WebView Android común (opcional pero útil)
                const isWebViewAndroid =
                isAndroid && /wv|Version\/\d+\.\d+.*Chrome\/\d+/i.test(ua);

                // ❌ Navegadores que NO pueden con printJS → visor directo
                if (isAndroid || isWebViewAndroid || isChromeiOS) {
                const win = window.open(pdfURL, "_blank");
                if (!win) window.location.href = pdfURL;
                setTimeout(() => URL.revokeObjectURL(pdfURL), 60000);
                return;
                }

                // ✅ Navegadores que SÍ pueden (o al menos vale la pena intentar)
                // Intentamos printJS y NO hacemos fallback si falla
                try {
                printJS({
                    printable: pdfURL,
                    type: "pdf",
                    showModal: false,
                });
                } catch (e) {
                // Si falla de inmediato, NO hacemos nada más
                message.error("No se pudo imprimir el ticket automáticamente. Cambie de navegador (por ejemplo, Chrome o Firefox).");
                console.warn("printJS falló inmediatamente:", e);
                }

                // No revocar rápido o rompes printJS
                setTimeout(() => URL.revokeObjectURL(pdfURL), 60000);
            });
        }
    }

    cerrar = () => {
        this.props.onCancel?.();
    };

    agregarCliente = () => {
        // Puedes abrir otra ruta o un modal según tu flujo
        this.props.history?.push?.("/panel/agregarCliente");
    };

    onChangeCliente = (valueId) => {
        const cliente = this.state.todasClientes?.find((c) => c._id === valueId);
        if (!cliente) return;

        if (!cliente.regimenFiscalId || !cliente.direcciones[0]?.coloniaId) {
            message.info("No se podrá facturar a este cliente. Faltan datos");
        }
        if (!cliente.tipoClienteId) {
            const nombre = cliente.persona
                ? cliente.razonSocial
                : `${cliente.nombre} ${cliente.apellidoPaterno} ${cliente.apellidoMaterno}`;
            this.abrirElegirTipoDeCliente(cliente._id, nombre);
        }
        this.setState({
            complementoDetallista: cliente.complementoDetallista,
            detallista: {
                orderIdentification: cliente.orderIdentification,
                referenceDateOrderIdentification: cliente.referenceDateOrderIdentification,
                additionalInformation: cliente.additionalInformation,
                deliveryNote: cliente.deliveryNote,
                referenceDateDeliveryNote: cliente.referenceDateDeliveryNote,
            },
        });
        this.formRef.current?.setFieldsValue({
            usoDeCfdiId: cliente.usoDeCFDIID,
            regimenClienteFiscalId: cliente.regimenFiscalId,
        });
    };

    abrirElegirTipoDeCliente = (id, nombre) => {
        this.setState({
            modalElegirTipoDeCliente: true,
            modalElegirTipoDeClienteId: id,
            modalElegirTipoDeClienteNombre: nombre,
        });
    };

    cerrarElegirTipoDeCliente = (elegido) => {
        if (!elegido) {
            this.formRef.current?.setFieldsValue({ clienteFacturaId: undefined });
        }
        // refrescar datos (por si se actualizó el cliente)
        this.consultarTodo();
        this.setState({
            modalElegirTipoDeCliente: false,
            modalElegirTipoDeClienteId: null,
            modalElegirTipoDeClienteNombre: null,
        });
    };

    cerrarMandarCorreo = () => {
        this.setState({
            modalCorreo: false,
            modalCorreoId: null,
        });
        this.formRef.current?.resetFields();
        this.cerrar();
    };

    onChangeCambiarCliente = (value) => {
        if (!value) {
            const c = this.state.datosVenta?.cliente;
            this.setState({
                complementoDetallista: c?.complementoDetallista,
                detallista: {
                    orderIdentification: c?.orderIdentification,
                    referenceDateOrderIdentification: c?.referenceDateOrderIdentification,
                    additionalInformation: c?.additionalInformation,
                    deliveryNote: c?.deliveryNote,
                    referenceDateDeliveryNote: c?.referenceDateDeliveryNote,
                },
            });
        } else {
            this.setState({ complementoDetallista: false });
        }
    };

    render() {
        const { visible } = this.props;
        const { datosVenta } = this.state;

        return (
            <Modal
                visible={visible}
                title={
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <span>Generar Factura sobre Venta</span>
                    </div>
                }
                onCancel={this.props.onCancel}
                footer={null}
                width={1000}
                maskClosable={false}
                destroyOnClose
                zIndex={1040}
                bodyStyle={{ paddingTop: 8, paddingBottom: 8, maxHeight: "70vh", overflow: "auto" }}
            >
                <Spin spinning={this.state.loading}>
                    <Form
                        ref={this.formRef}
                        name="generarFacturaventaModal"
                        layout
                        bottom={
                            <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                                <ButtonItem onClick={this.cerrar} rojo>Cancelar</ButtonItem>
                                <ButtonItem type="primary" htmlType="submit">
                                    Generar
                                </ButtonItem>
                            </div>
                        }
                        onFinish={this.onFinish}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <Tabs defaultActiveKey={1} size="small">
                            <TabPane tab="General" tabKey={1} key={1} forceRender>
                                <Row gutter={[16, 8]}>
                                    <Col span={24}>
                                        {this.state.activarRegimenes && (
                                            <>
                                                <HeaderItem>REGIMEN FISCAL</HeaderItem>
                                                <BoxItem>
                                                    <FormItem
                                                        label="Regimen Fiscal"
                                                        name="regimenFiscalId"
                                                        margin
                                                        required
                                                    >
                                                        <SelectItem placeholder="Regimen Fiscal">
                                                            {this.state.objetoRegimenFiscal}
                                                        </SelectItem>
                                                    </FormItem>
                                                </BoxItem>
                                            </>
                                        )}
                                        <HeaderItem>DATOS CLIENTE</HeaderItem>
                                        <BoxItem>
                                            <FormItem
                                                name="cambiarCliente"
                                                label="Cambiar Cliente"
                                                margin
                                                valuePropName="checked"
                                                initialValue={false}
                                            >
                                                <SwitchItem onChange={this.onChangeCambiarCliente} />
                                            </FormItem>

                                            <FormItem shouldUpdate noStyle>
                                                {({ getFieldValue }) => {
                                                    const cambiarCliente = getFieldValue("cambiarCliente");
                                                    if (cambiarCliente) {
                                                        return (
                                                            <FormItem margin label="Cliente">
                                                                <Input.Group compact>
                                                                    <FormItem name="clienteFacturaId" noStyle required>
                                                                        <SelectItem
                                                                            onChange={this.onChangeCliente}
                                                                            placeholder="Cliente"
                                                                            width="80%"
                                                                        >
                                                                            {this.state.objetoClientes}
                                                                        </SelectItem>
                                                                    </FormItem>
                                                                    <ButtonItem
                                                                        disabled
                                                                        icon={<PlusOutlined />}
                                                                        style={{ width: "20%" }}
                                                                        onClick={this.agregarCliente}
                                                                    />
                                                                </Input.Group>
                                                            </FormItem>
                                                        );
                                                    }
                                                    return null;
                                                }}
                                            </FormItem>
                                            <FormItem
                                                label="Regimen Fiscal Cliente"
                                                name="regimenClienteFiscalId"
                                                margin
                                                required
                                            >
                                                <SelectItem placeholder="Regimen Fiscal Cliente">
                                                    {this.state.objetoRegimenFiscalCliente}
                                                </SelectItem>
                                            </FormItem>
                                            <FormItem
                                                name="formaDePagoId"
                                                label="F Pago"
                                                margin
                                                required
                                            >
                                                <SelectItem disabled={this.state.contado === 2} placeholder="Forma de Pago">
                                                    {this.state.objetoFormasDePago}
                                                </SelectItem>
                                            </FormItem>

                                            <FormItem name="usoDeCfdiId" label="Uso de CFDI" margin required>
                                                <SelectItem placeholder="Uso de CFDI">
                                                    {this.state.objetoUsosDeCFDI}
                                                </SelectItem>
                                            </FormItem>
                                            <FormItem
                                                name="ordenDeCompra"
                                                label="O Compra"
                                                margin
                                                pattern
                                            >
                                                <InputItem placeholder="Orden de Compra" />
                                            </FormItem>
                                        </BoxItem>
                                    </Col>
                                </Row>

                                <Divider style={{ marginBottom: 10, marginTop: 5 }} />

                                <Row>
                                    <Col span={16} xs={24} sm={24} lg={16} xl={16} />
                                    <Col span={8} xs={24} sm={24} lg={8} xl={8}>
                                        <h1 style={{ textAlign: "center", fontSize: 20 }}>Total Venta</h1>
                                        {datosVenta && (
                                            <table className="table">
                                                <tbody>
                                                    <tr>
                                                        <th className="th-totales" style={{ width: "50%" }}>
                                                            Subtotal
                                                        </th>
                                                        <td className="td-totales-right" style={{ width: "50%" }}>
                                                            {dineroDisabledMask(datosVenta.subtotal)}
                                                        </td>
                                                    </tr>
                                                </tbody>

                                                {datosVenta.arrayImpuestos?.map((valueArray) => (
                                                    <tbody key={valueArray.descripcionFactura}>
                                                        <tr>
                                                            <th className="th-totales">{valueArray.descripcionFactura}</th>
                                                            <td className="td-totales-right">
                                                                {dineroDisabledMask(valueArray.totalImpuestos)}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                ))}

                                                <tbody>
                                                    <tr>
                                                        <th className="th-totales">Total</th>
                                                        <td className="td-totales-right">
                                                            {dineroDisabledMask(datosVenta.total)}
                                                        </td>
                                                    </tr>
                                                </tbody>

                                                {datosVenta.arrayRetenciones?.map((valueArrayRet) => (
                                                    <tbody key={valueArrayRet.descripcionFactura}>
                                                        <tr>
                                                            <th className="th-totales">
                                                                {valueArrayRet.descripcionFactura}
                                                            </th>
                                                            <td className="td-totales-right">
                                                                {dineroDisabledMask(valueArrayRet.totalRetenciones)}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                ))}

                                                <tbody>
                                                    <tr>
                                                        <th className="th-totales">Total Pagar</th>
                                                        <td className="td-totales-right">
                                                            {dineroDisabledMask(datosVenta.totalPagar)}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        )}
                                    </Col>
                                </Row>
                            </TabPane>

                            {this.state.complementoDetallista && this.props.complementoDetallista ? (
                                <TabPane tab="Detallista" tabKey={2} key={2} forceRender>
                                    {this.state?.detallista?.orderIdentification && (
                                        <FormItem
                                            name="orderIdentification"
                                            label="OrderIdentification"
                                            margin
                                            labelCol={{ span: 6 }}
                                            wrapperCol={{ span: 18 }}
                                            required
                                        >
                                            <InputItem placeholder="OrderIdentification" />
                                        </FormItem>
                                    )}

                                    {this.state?.detallista?.referenceDateOrderIdentification && (
                                        <FormItem
                                            name="referenceDateOrderIdentification"
                                            label="ReferenceDateOrderIdentification"
                                            margin
                                            labelCol={{ span: 6 }}
                                            wrapperCol={{ span: 18 }}
                                            required
                                        >
                                            <DatePickerItem placeholder="ReferenceDateOrderIdentification" />
                                        </FormItem>
                                    )}

                                    {this.state?.detallista?.additionalInformation && (
                                        <>
                                            <FormItem
                                                name="typeAdditionalInformation"
                                                label="TypeAdditionalInformation"
                                                margin
                                                labelCol={{ span: 6 }}
                                                wrapperCol={{ span: 18 }}
                                                required
                                            >
                                                <SelectItem placeholder="Type - AdditionalInformation">
                                                    <Option value="AAE">AAE - Cuenta predial</Option>
                                                    <Option value="CK">CK - Número de cheque</Option>
                                                    <Option value="ACE">ACE - Numero de documento(Remisión)</Option>
                                                    <Option value="ATZ">ATZ - Número de aprobación.</Option>
                                                    <Option value="AWR">AWR - Numero de documento que  se reemplaza</Option>
                                                    <Option value="ON">ON - Número de pedido (comprador)</Option>
                                                    <Option value="DQ">DQ - Folio de recibo de mercancías</Option>
                                                    <Option value="IV">IV - Número de Factura</Option>
                                                </SelectItem>
                                            </FormItem>

                                            <FormItem
                                                name="referenceIdentificationAdditionalInformation"
                                                label="ReferenceIdentification"
                                                margin
                                                labelCol={{ span: 6 }}
                                                wrapperCol={{ span: 18 }}
                                                required
                                            >
                                                <InputItem placeholder="ReferenceIdentification - AdditionalInformation" />
                                            </FormItem>
                                        </>
                                    )}

                                    {this.state?.detallista?.deliveryNote && (
                                        <FormItem
                                            name="deliveryNote"
                                            label="DeliveryNote"
                                            margin
                                            labelCol={{ span: 6 }}
                                            wrapperCol={{ span: 18 }}
                                            required
                                        >
                                            <InputItem placeholder="DeliveryNote" />
                                        </FormItem>
                                    )}

                                    {this.state?.detallista?.referenceDateDeliveryNote && (
                                        <FormItem
                                            name="referenceDateDeliveryNote"
                                            label="ReferenceDateDeliveryNote"
                                            margin
                                            labelCol={{ span: 6 }}
                                            wrapperCol={{ span: 18 }}
                                            required
                                        >
                                            <DatePickerItem placeholder="ReferenceDateDeliveryNote" />
                                        </FormItem>
                                    )}
                                </TabPane>
                            ) : null}
                        </Tabs>
                    </Form>
                </Spin>

                <ElegirTipoDeCliente
                    visible={this.state.modalElegirTipoDeCliente}
                    id={this.state.modalElegirTipoDeClienteId}
                    nombre={this.state.modalElegirTipoDeClienteNombre}
                    cerrarElegirTipoDeCliente={this.cerrarElegirTipoDeCliente}
                    zIndex={1200}
                />

                <MandarCorreo
                    zIndex={1200}
                    visible={this.state.modalCorreo}
                    id={this.state.modalCorreoId}
                    cerrarMandarCorreo={this.cerrarMandarCorreo}
                />
            </Modal>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    complementoDetallista: state.empresa.complementoDetallista,
});

export default connect(mapStateToProps)(ModalGenerarFactura);
